import { Component, OnInit } from '@angular/core';

interface Location {
  id?: number;
  places?: string[];
}

@Component({
  selector: 'app-voucher-city-record',
  templateUrl: './voucher-city-record.component.html',
  styleUrls: ['./voucher-city-record.component.scss'],
})
export class VoucherCityRecordComponent implements OnInit {
  location: Location = { id: 0, places: [] };

  constructor() { }

  ngOnInit() {
  }

  addPlace() {
    this.location.places.push('');
  }

  removePlace(index: number) {
    this.location.places.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/voucher-city-record/voucher-city-record.component.ts